import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreatePlatformDTO, Platform, UpdatePlatformDTO } from '../models/platform';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  url = `${environment.url}/api`;
    
  constructor(
    private http: HttpClient
  ) { }

  platformsBs: BehaviorSubject<Platform[]> = new BehaviorSubject<Platform[]>([]);

  public getAll() {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(`${this.url}/plataformas`, { headers });
  }

  create(data: CreatePlatformDTO) {
    return this.http.post(`${this.url}/plataformas`, data);
  }

  update(data: UpdatePlatformDTO) {
    return this.http.put(`${this.url}/plataformas/${data.id}`, data);
  }

  delete(id: number) {
    return this.http.delete(`${this.url}/plataformas/${id}`);
  }

  getPlatforms() {
    return this.platformsBs.getValue();
  }

  updatePlatforms(platforms: Platform[]) {
    this.platformsBs.next(platforms);
  }
}
